// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2roGn","inner":"Footer_inner__3OzB3","nextIcon":"Footer_nextIcon__PrBBL","innerLeft":"Footer_innerLeft__eLgHZ"};